module.exports = __webpack_public_path__ + "fonts/27b081f4551e52b94952dd513939cf8f.txt";